/**
 * The Message shortcut on a Followers row (ISSUE-1372). It reuses the one
 * DM start flow, `useOpenPrivateChat`, and remembers which row was tapped so
 * only that row's button shows it is busy.
 */
import { useState } from "react";

import { useOpenPrivateChat } from "../messages/useOpenPrivateChat";

export function useMessageShortcut(): {
  openingAccountId: string | null;
  message: (accountId: string) => void;
} {
  const { openPrivateChat } = useOpenPrivateChat();
  const [openingAccountId, setOpeningAccountId] = useState<string | null>(null);
  return {
    openingAccountId,
    message: (accountId) => {
      setOpeningAccountId(accountId);
      void openPrivateChat(accountId).finally(() => {
        setOpeningAccountId(null);
      });
    },
  };
}
